export enum CompanyRole {
    Administrator = 'Administrator',
    Seller = 'Seller',
    BrokerDealer = 'BrokerDealer',
    Viewer = 'Viewer',
    CollateralManager = 'CollateralManager',
    Media = 'Media'
}
